import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Tag } from '../models/tag.model';
import { TagService } from '../services/tag.service';
import { MatCheckbox, MatCheckboxChange, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-edit-tag',
  templateUrl: './edit-tag.component.html',
  styleUrls: ['./edit-tag.component.scss']
})
export class EditTagComponent implements OnInit, AfterContentInit {

  @Input() tags: Array<Tag>;
  @Input() business: any;
  @Output() change = new EventEmitter<boolean>();
  @Output() error = new EventEmitter<Error>();
  @ViewChildren('checkbox') checkBoxes: QueryList<MatCheckbox>;
  constructor(private _tagService: TagService,
              private _snackBar: MatSnackBar) {}

  ngOnInit() {
  }

  ngAfterContentInit() {
  }

  isChecked(tagId: number): boolean {
    const TAGS = this.business.tags || this.business.airportTags;
    for (const tag of TAGS) {
      if (tag.tagId === tagId) {
        return true;
      }
    }
    return false;
  }

  async checkBoxChanged (event: MatCheckboxChange) {
    const TAG_ID = +event.source.id;
    // const BUSINESS_ID = this.business.id || this.business.airportId;
    try {
      if (event.source.checked) {
        if (this.business.airportId) {
          await this._tagService.postAirportTag(TAG_ID, this.business.airportId);
        } else {
          await this._tagService.postTag(TAG_ID, this.business.id);
        }
        this.change.emit();
      } else {
        if (this.business.airportId) {
          /* the following section prevents removing the restaurant on field tag when there are local attractions that are
          restaurants on field */
          if (TAG_ID === 49183 && this.business.localAttractions.filter(a => a.travelType === 'Restaurant On Field').length > 0) {
            event.source.checked = true;
            this._snackBar.open(
              'There is a local attraction that is a restaurant on the field.  It must be removed before this tag can be removed.',
              'Invalid Tag Removal',
              {
                duration: 5000
            });
            return;
          }
          await this._tagService.deleteAirportTag(TAG_ID, this.business.airportId);
        } else {
          await this._tagService.deleteTag(TAG_ID, this.business.id);
        }
        this.change.emit();
      }
    } catch (e) {
      this.error.emit(new Error('API Call Failed'));
    }
  }
}
